import { useState, useEffect, useCallback } from 'react';
import { axiosApi } from '../../api/setupApi';

const useCisNosoByYear = (year) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);

  const fetchData = useCallback(async () => {
    if (!year) return;
    setLoading(true);

    try {
      const { data } = await axiosApi.get(`/cisNoso/byYear/${year}`);
      setData(Array.isArray(data) ? data : []);
      setError(null);
    } catch (err) {
      setError(err?.response?.data?.error || 'Failed to fetch CIS NOSO data by year');
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [year]);

  useEffect(() => {
    fetchData();
  }, [fetchData, refreshIndex]);

  const refetch = () => setRefreshIndex((prev) => prev + 1);

  return { data, loading, error, refetch };
};

export default useCisNosoByYear;
